// src/components/ViewBanner.js

import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";

export const ViewBanner = () => {
  const { id } = useParams();
  const [banner, setBanner] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const response = await axios.get(
          "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/banner_image_list"
        );
        const data = response.data.data.find((b) => b.ban_id === id);
        if (data) {
          setBanner(data);
        } else {
          toast.error("Banner not found!");
          navigate("/Master/Banner");
        }
      } catch (err) {
        toast.error("Failed to load banner.");
        navigate("/Master/Banner");
      }
    };

    fetchBanner();
  }, [id, navigate]);

  return (
    <div className="container mt-5">
      <h2 className="mb-4">View Banner</h2>
        <Link to="/Master/Banner">
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                ></button>
              </Link>
      {banner ? (
        <div className="card p-3">
          <img
            src={`https://cyberathon.com/silverapartment/${banner.banner_img}`}
            alt="Banner"
            className="img-fluid rounded"
            style={{ maxWidth: "400px" }}
          />
        </div>
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
};

export default ViewBanner;
